export const projects = [
    {
      title: "Omen: Multiplatform kernel",
      subtitle: "C",
      description: 
        "Fast and resilient kernel based on UNIX that aims to be ultra-stable.",
      image: "./Omen.png",
      link: "https://github.com/omen-osdev/omen"
    },
    {
      title: "Landslide simulator",
      subtitle: "Cuda",
      description:
        "Landslide simulations using cellular automatas and parallelized on the GPU using CUDA",
      image: "./CUDA.jpg",
      link: "https://github.com/JanDuinkerken/GPU-SciddicaT"
    },
    {
      title: "Task Management App Backend",
      subtitle: "NestJS",
      description:
        "Task management app backend created using the NodeJS framework NestJS. It handles creation, deletion, searching and updating tasks as well as user creation and login.",
      image: "./Nest.jpg",
      link: "https://github.com/JanDuinkerken/nestjs-task-management.git",
    },
    {
      title: "Task Management App Frontend",
      subtitle: "ReactJS",
      description:
        "ReactJS frontend for the Task Management Backend. Styled using the Bulma framework. It shows the task each user has color coded depending on the state they are in.",
      image: "./React.jpg",
      link: "https://github.com/JanDuinkerken/reactjs-task-management.git",
    },
  ];

  export const skills = ["C", "C++", "Java", "Python", "SQL", "Javascript", "Typescript", "Julia", "Ocaml", "Rust", "Erlang", "R", "Matlab"];

  export const work = [
   {
       quote: "2 years as a fullstack developer",
       image: "./SNGULAR.jpg",
       company: "SNGULAR"
   },
  ];